import Swiper from 'swiper/dist/js/swiper';
// import Api from '../../base/script/api';
// import InputCountry from '../../core/input/country/input-country';
// import AnimationFade from '../../core/animation/fade/animation-fade';
// import UtmData from '../../base/script/utmData';

import CardTempl from './card-slider.pug';

export default {
  props: ['items'],
  template: CardTempl(),
  delimiters: ['${', '}}'],
  components: {
    // AnimationFade,
    // InputCountry,
  },
  data() {
    return {
      slider: {
        options: {
          slidesPerView: 1,
          resistance: true,
          resistanceRatio: 0,
          preloadImages: false,
          lazy: {
            loadPrevNext: false,
          },
          // autoplay: {
          //   delay: 4000,
          // },
          pagination: {
            bulletClass: 'card-slider__slider-hover-el',
            bulletActiveClass: 'card-slider__slider-hover-el--active',
            clickable: false,
            renderBullet(index, className) {
              return `<span class="${className}" style="width: calc(${100 / this.slides.length}% - 4px)"></span>`;
            },
          },
        },
        instance: undefined,
      },
      sliderInited: false,
    };
  },
  computed: {
    slidesCut() {
      return this.items.slice(0, 7);
    },
  },
  methods: {
    initSlider() {
      const slides = [].slice.call(this.card.querySelectorAll('.card-slider__slide'));

      if (slides.length > 1) {
        this.slider.wrp = this.card.querySelector('.card-slider__slider');
        this.slider.options.pagination.el = this.slider.wrp.querySelector('.card-slider__slider-hover');
        this.sliderInited = true;
        this.$nextTick(() => {
          this.slider.instance = new Swiper(this.slider.wrp, this.slider.options);
          const sliderHovers = [].slice.call(this.slider.wrp.querySelectorAll('.card-slider__slider-hover-el'));

          if (this.slider.instance !== undefined && this.slider.instance.initialized) {
            sliderHovers.forEach((hover, index) => {
              hover.addEventListener('mouseenter', () => {
                if (window.innerWidth >= 1024) {
                  this.slider.instance.slideTo(index);
                }
              });
            });
          }
        });
      }
    },
    openFullPopup() {
      this.$emit('open-fullscreen-popup', {
        active: this.slider.instance ? this.slider.instance.activeIndex : 0,
        cards: this.items,
      });
    },
  },
  mounted() {
    this.card = this.$el;
    this.initSlider();
  },
};



// WEBPACK FOOTER //
// ./new-blocks/card/card-slider/card-slider.js